module.exports = "'data:image/svg+xml;utf8,<svg width=\"10\" height=\"2\" viewBox=\"0 0 10 2\" xmlns=\"http://www.w3.org/2000/svg\"><title>Slice 1</title><path fill=\"%23D3DAE7\" d=\"M0 0h10v2H0z\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/InheritanceTree/rootNode.svg
 ** module id = 1415
 ** module chunks = 0
 **/